import { boardStats } from "@/mocks/home";

export default function StatsBar() {
  return (
    <section id="board" className="w-full bg-primary-500">
      <div className="w-full max-w-site mx-auto px-4 md:px-6 py-6 md:py-7">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-6 sm:gap-y-7 lg:gap-y-0">
          {boardStats.map((stat, index) => (
            <div
              key={stat.label}
              className={`flex items-center gap-3.5 sm:px-6 lg:px-8 ${
                index !== 0 ? "lg:border-l lg:border-background-50/25" : ""
              }`}
            >
              <span className="w-11 h-11 shrink-0 rounded-md bg-background-50/15 text-background-50 flex items-center justify-center">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <div>
                <div className="flex items-baseline gap-2">
                  <span className="font-heading text-2xl md:text-[26px] font-bold text-background-50">
                    {stat.value}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-background-50/85 mt-0.5">
                  {stat.label}
                </p>
                <p className="text-[11px] text-background-50/70 mt-0.5">{stat.trend}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}